import React from "react";

export const IconLectern = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m15.276 20.018 3.098-3.0979c0.7289-0.729 0.7289-1.8224 0-2.5513-0.729-0.7289-1.8223-0.7289-2.5513 0l-6.7426 6.7426c-1.1845 1.1845-3.0068 1.1845-4.1914 0s-1.1845-3.0068 0-4.1913l0.36447-0.3645m13.759-9.2938c1.1845-1.1845 1.1845-3.098 0-4.3736-1.1845-1.1845-3.098-1.1845-4.3736 0-0.3645 0.36447-0.5467 0.72893-0.7289 1.1845-0.6378 1.549-1.6401 2.4601-1.6401 2.4601l1.549 1.549 1.5489 1.4579s0.9112-0.91116 2.4602-1.6401c0.4556-0.09111 0.82-0.27335 1.1845-0.63781zm-13.394 9.5672-0.5467-0.5467c-0.36446-0.3645-0.36446-0.8201 0-1.1845l7.5627-8.3827 2.5512 2.6424-8.3827 7.4716c-0.36446 0.3644-0.91116 0.3644-1.1845 0z"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
  </svg>
);

export default IconLectern;
